<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Report - {{this.subTitle}}</h2>
			</b-col>
			<!--Gear Icon-->
			<b-col lg="6">
				<!-- <b-btn class="pull-right" v-b-popover.hover.top="'Select Datapoints'" variant="info" @click="configTable = true"><i class="fa fa-cog"></i></b-btn> -->
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
						<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editTerminal">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteTerminal">Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>

		<div>
			<b-card v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
			</b-card>
			<div v-else>
				<b-card v-if="found">
					<b-row>
						<b-col md="8">
							<b-form-group :label-cols="4" id="L1" label="Company Type" label-for="pw0" horizontal>
								<b-form-input v-if="!edit" class="plaintext-input" plaintext id="pw0" v-model="model.company_type" type="text"></b-form-input>
								<b-form-select v-else id="pw0" value-field="id" text-field="name" v-model="model.company_type_id" :options="company_type" @input="select_company_type()"/>
							</b-form-group>
                            <b-form-group :label-cols="4" id="L2" label="Company Name" label-for="pw1" horizontal>
								<b-form-input v-if="!edit" class="plaintext-input" plaintext id="pw1" v-model="model.company_name" type="text"></b-form-input>
								<b-form-select v-else id="pw1" value-field="id" text-field="name" v-model="model.company_id" :options="company_name" @input="select_company()"/>       
							</b-form-group>
							<b-form-group :label-cols="4" id="L3" label="Report Name" label-for="pw2" horizontal>
								<b-form-input  v-if="!edit" plaintext class="plaintext-input" id="pw2" v-model="model.report_name" type="text"></b-form-input>	
								<b-form-input  v-else class="plaintext-input" id="pw2" v-model="model.report_name" type="text"></b-form-input>							
							</b-form-group>
							<b-form-group :label-cols="4" id="L17" label="Activate Power Bi" label-for="ULID" horizontal>
								<b-form-checkbox v-if="!edit"
                					id="ULID"
									class="custom-checkboxes"
                					v-model="model.activate_pb" 
							  		style="margin-top: 13px;"
									disabled
              					></b-form-checkbox>	
								<b-form-checkbox v-else
                					id="ULID"
									class="custom-checkboxes"
                					v-model="model.activate_pb" 
							  		style="margin-top: 13px;"
									@change="toggle"
              					></b-form-checkbox>	
					  		</b-form-group>	

							<b-form-group v-if ="!model.activate_pb && edit" :label-cols="4" id="L1" label="Pdf File" label-for="pwb2" horizontal>
								<b-form-input v-if ="model.pdf!==''" plaintext class="plaintext-input" id="pw2" v-model="model.pdf" type="text"></b-form-input>							
							<!--	<b-button v-if="edit" @click="change_file()" size="sm">Change</b-button>-->
								<input type="file" id="files" accept="application/pdf" ref="file" v-on:change="handleFileUpload()" />
			      			</b-form-group>
							<b-form-group v-if ="!model.activate_pb && !edit" :label-cols="4" id="L1" label="Pdf File" label-for="pwb2" horizontal>
								<b-form-input plaintext class="plaintext-input" id="pw2" v-model="model.pdf" type="text"></b-form-input>								
			      			</b-form-group>
						<!--	<b-form-group v-if ="edit && !model.activate_pb && change" :label-cols="4" id="L1" label="Pdf File" label-for="pwb2" horizontal>						
				      			
			      			</b-form-group>  -->
                            <b-form-group v-if="model.activate_pb" :label-cols="4" id="L4" label="Url" label-for="pw3" horizontal>
								<b-form-input v-if="!edit" plaintext class="plaintext-input" id="pw3" v-model="model.url" type="text"></b-form-input>	
								<b-form-input v-else class="plaintext-input" id="pw3" v-model="model.url" type="text"></b-form-input>							
							</b-form-group>
                            <b-embed v-if="model.url!=''"
                                type="iframe"
                                aspect="16by9"
                                allowfullscreen
                                frameborder="0"
                                :src=model.url
                            ></b-embed> 
							<br>
							<div slot="footer" v-show="edit">
								<b-button @click="updateTerminal" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
								<b-button @click="editTerminal" size="sm"><i class="fa fa-ban"></i> Cancel</b-button>
							</div>
						</b-col>
					</b-row>
					<!-- </b-tab> -->
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
						<p class="text-center text-danger">
							<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
						</p>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
	import pwbi_service from './pwbi_service'
	export default {
		name: 'PowerBi',
		created: function() {
			this.getTerminalData()
		},
		props: {
			id: {
				type        : String,
				default     : 0
			}
		},
		data() {
			return {
				subTitle        : '',
				edit            : false,
				found           : false,
				notFoundMessage : 'Not found',
				model           : {
                    id              : null,
                    company_type_id : null,
                    company_type    : '',
                    company_id      : null,
					company_name    : '',
					report_name     : '',
					activate_pb     : true,
					url             : '',
					pdf             : '',
				},
				updateData      : null,
				originalData    : null,
                loadingData     : true,
                terminalId      : null,
                company_type    : [],
                company_name    : [],
				role            : '',
				file			: '',
				change          : false,
				url             : '',
				pdf_file        : '',
				url_save        : '',

			}
		},
		methods: {
			toggle(checked) {
				if (!checked) {
					this.url_save  = this.model.url
					this.model.url = ''
				} else {
					this.model.url = this.url_save
				}
      		}, 
			handleFileUpload() {
				if (!this.model.activate_pb) {
					this.file = this.$refs.file.files[0]
					this.model.pdf = this.file['name']
					this.url = window.URL.createObjectURL(this.file)
					setTimeout(() => window.URL.revokeObjectURL(this.url), 100)
					this.model.url = this.url
				}
      		},
			editTerminal() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.setupFields()
					this.edit = true
				}
			},
			restoreOriginalData() {
				let model = {
					...this.originalData,
				}
				this.model = model
				this.change = false
				if (!this.model.activate_pb) {
					// this.model.url = this.url
					this.model.url = ''
				}
			},
			setupFields() {
                if (this.role =='super_admin') {         
                    if (this.model.company_type_id === 0) {
                        this.company_name  =  this.company_type[0].energy_companies  
                    } else {
                        this.company_name  =  this.company_type[1].trucking_companies
					}	 
					this.change = false
                }
			},
			getTerminalData() {
				pwbi_service.getBy(this.id)
					.then(data => {
						if (data.status == 'success') {
							this.originalData   = data.powerbi
							this.terminalId     = this.id
							this.loadingData    = false
							this.found          = true
							let pdf_file 		= data.pdf_file
							console.log()
							if (pdf_file!=='') {
								let url = window.URL.createObjectURL(this.base64ToBlob(pdf_file))
								this.url = url
								setTimeout(() => window.URL.revokeObjectURL(url), 100)					
							}
							this.restoreOriginalData()	
                            this.subTitle       = this.originalData.report_name
                            this.company_type   = data.update_data.pwbi 
							this.role 			= data.role

						}else {
                            this.$swal(data.status, data.message, data.status)
                            this.loadingData = false
                            return
                        }
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
                if (this.model.company_id  === undefined || this.model.company_id == null) {
					this.$swal('Alert!', 'Select Company', 'warning')
					return false
				} else if (this.model.company_name  === undefined || this.model.company_name === '') {
					this.$swal('Alert!', 'Select Company', 'warning')
					return false
				}  else if (this.model.report_name === '' || this.model.report_name === null) {
					this.$swal('Alert!', 'Please, Enter Report Name', 'warning')
					return false
				}

				if (this.model.activate_pb) {
          			if (this.model.url === '') {
					  this.$swal('Alert!', 'Please, Enter Url', 'warning')
					  return false
				  	}
				} else {
          			if (this.model.pdf === '') {
					  this.$swal('Alert!', 'Please, Enter Pdf file', 'warning')
					  return false
				  	}          
        		}
				return true
			},
            updateTerminal () {
                if (!this.okToUpdate()) {
					return
				}
				const json = JSON.stringify(this.model);
        		const blob = new Blob([json], {
          			type: 'application/json'
        		})
        		let formData = new FormData()
        		formData.append("document", blob)
        		formData.append('file', this.file)
				pwbi_service.update(this.terminalId, formData)
					.then((data) => {
						this.$swal(data[0], data[1], data[0])
							.then((result) => {
								this.getTerminalData()
							})
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
				this.edit=false
			},
			deleteTerminal(item) {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Power Bi for " + this.model.company_name + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						pwbi_service.delete(this.terminalId)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.$router.replace('/powerbi')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
            },
            select_company_type() {
                if (this.role =='super_admin') {         
                    if (this.model.company_type_id === 0) {
                        this.company_name  =  this.company_type[0].energy_companies  
                        this.model.company_id  = null
                    } else {
                        this.company_name  =  this.company_type[1].trucking_companies
                        this.model.company_id  = null
                    }	 
                }
            },
    select_company() {
        if (this.role =='super_admin') {        
            let companies = this.company_name
			let company_index = companies.map(o => o.id).indexOf(this.model.company_id)
			if (company_index > -1) {
			    this.model.company_name = companies[company_index].name
			} else {
                this.model.company_name = ''
			}
        }
	},
	base64ToBlob(base64) {
  		const binaryString = window.atob(base64);
  		const len = binaryString.length;
  		const bytes = new Uint8Array(len);
  		for (let i = 0; i < len; ++i) {
    		bytes[i] = binaryString.charCodeAt(i);
  		}

  		return new Blob([bytes], { type: 'application/pdf' });
	},
	change_file() {
		if (!this.model.activate_pb) {
			this.change = true
			this.model.url = ''	
		}
	},
	blobToFile(theBlob, fileName){       
    	return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type })
	}
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/powerbi/pwbi_detail.vue